import { render, staticRenderFns } from "./BasicChatWidget.vue?vue&type=template&id=181dcda4&scoped=true"
import script from "./BasicChatWidget.vue?vue&type=script&lang=js"
export * from "./BasicChatWidget.vue?vue&type=script&lang=js"
import style0 from "./BasicChatWidget.vue?vue&type=style&index=0&id=181dcda4&prod&lang=scss"
import style1 from "./BasicChatWidget.vue?vue&type=style&index=1&id=181dcda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181dcda4",
  null
  
)

export default component.exports